import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { OrderShift, Shift } from "~/providers/shift-provider";

interface ShiftStoreState {
  shiftFormOpen: boolean;
  shiftStatusFormOpen: boolean;
  selectedDate?: Date;
  orderShiftFormOpen: boolean;
  currentOrderShift?: OrderShift;
  currentShift?: Shift;
  setShiftFormOpen: (shiftFormOpen: boolean) => void;
  setShiftStatusFormOpen: (open: boolean) => void;
  setSelectedDate: (date: Date) => void;
  setOrderShiftFormOpen: (orderShiftFormOpen: boolean) => void;
  setCurrentShift: (currentShift?: Shift) => void;
  setCurrentOrderShift: (currentOrderShift?: OrderShift) => void;
}

export const useShiftStore = create<ShiftStoreState>()(
  devtools((set) => ({
    shiftFormOpen: false,
    shiftStatusFormOpen: false,
    orderShiftFormOpen: false,
    setSelectedDate(date) {
      set(() => ({ selectedDate: date }));
    },
    setShiftStatusFormOpen(open) {
      set(() => ({ shiftStatusFormOpen: open }));
    },
    setShiftFormOpen(shiftFormOpen) {
      set(() => ({ shiftFormOpen }));
    },
    setCurrentShift(currentShift) {
      set(() => ({ currentShift }));
    },
    setCurrentOrderShift(currentOrderShift) {
      set(() => ({ currentOrderShift }));
    },
    setOrderShiftFormOpen(orderShiftFormOpen) {
      set(() => ({ orderShiftFormOpen }));
    },
  })),
);
